'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EmailMetadata = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _attachmentTypes.EMAIL_METADATA), _defineProperty(_Record, 'to', (0, _immutable.List)()), _defineProperty(_Record, 'cc', (0, _immutable.List)()), _defineProperty(_Record, 'bcc', (0, _immutable.List)()), _defineProperty(_Record, 'from', (0, _immutable.Map)({
  name: '',
  email: ''
})), _defineProperty(_Record, 'subject', ''), _defineProperty(_Record, 'connectedAccountAddress', ''), _Record), 'EmailMetadata');

exports.default = EmailMetadata;
module.exports = exports['default'];